import HeaderDiagnostico from "@/components/diagnostico/HeaderDiagnostico";
import HeroDiagnostico from "@/components/diagnostico/HeroDiagnostico";
import ContextSection from "@/components/diagnostico/ContextSection";
import TargetAudience from "@/components/diagnostico/TargetAudience";
import DiagnosticForm from "@/components/diagnostico/DiagnosticForm";

const DiagnosticoPatrimonial = () => {
  return (
    <div className="min-h-screen bg-[#112711] relative overflow-x-hidden">
      <HeaderDiagnostico />

      <main>
        <HeroDiagnostico />
        <ContextSection />
        <TargetAudience />
        <DiagnosticForm />
      </main>
      
      {/* Footer */}
      <footer className="py-12 bg-[#112711] border-t border-[#FAFAFA]/10">
        <div className="section-container">
          <div className="flex flex-col items-center justify-center text-center">
            <div className="flex items-center gap-0.5 mb-4">
              <span className="text-lg font-body font-medium tracking-tight text-[#FAFAFA]">
                allu
              </span>
              <span className="text-lg text-[#F3DE2C]">.</span>
              <span className="text-lg font-body font-light tracking-tight text-[#FAFAFA]">
                capital
              </span>
            </div>
            <p className="text-sm text-[#FAFAFA]/60">
              © {new Date().getFullYear()} Allu Capital. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DiagnosticoPatrimonial;
